import {
  START_LOADING,
  LOAD_FAILURE,
  LOAD_SUCCESS,
  getKeys,
  CLEAR_CACHE,
} from 'types/datacache.constants';

export const PL_PREQUAL_RESULT_KEY = 'PL_PREQUAL_RESULT_KEY';
export const HOME_EQUITY_ENABLE = 'HOME_EQUITY_ENABLE';
export const AUTO_INSURANCE_KEY = 'AUTO_INSURANCE_KEY';
export const LIFE_INSURANCE_KEY = 'LIFE_INSURANCE_KEY';
export const HOME_INSURANCE_KEY = 'HOME_INSURANCE_KEY';
export const MARKETPLACE_FILTERS_KEY = 'MARKETPLACE_FILTERS_KEY';
export const CC_COMPARISON_KEY = 'CC_COMPARISON_KEY';

export const startLoadingForKey = key => {
  const { loading, error } = getKeys(key);
  return {
    type: START_LOADING,
    [key]: null,
    [loading]: true,
    [error]: null,
  };
};

export const cacheErrorForKey = (key, errorObj) => {
  const { loading, error } = getKeys(key);
  return {
    type: LOAD_FAILURE,
    [error]: errorObj,
    [loading]: false,
    [key]: null,
  };
};

export const cachePayloadForKey = (key, payload) => {
  const { loading, error } = getKeys(key);
  return {
    type: LOAD_SUCCESS,
    [error]: null,
    [loading]: false,
    [key]: payload,
  };
};

export const cacheClearForKey = key => ({
  type: CLEAR_CACHE,
  key,
});

export const selectForKey = (cacheKey, state) => {
  const { key, loading, error } = getKeys(cacheKey);
  return [
    state.datacache[key],
    state.datacache[loading],
    state.datacache[error],
  ];
};

export const isCacheInitialized = stateList => {
  if (Array.isArray(stateList)) return false;
  if (
    stateList[0] === undefined ||
    stateList[1] === undefined ||
    stateList[2] === undefined
  )
    return false;

  return (
    stateList[0] !== null || stateList[1] === true || stateList[2] !== null
  );
};
